module.exports = __webpack_public_path__ + "img/activityBtn.e1f769ad.png";